// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__VxKij","toggle":"checkbox_toggle__WEyIi"};